export function isSame(a: any, b: any) {
  return JSON.stringify(a) === JSON.stringify(b)
}

export function isEmptyObject(o: Object) {
  return o && o.constructor === Object && Object.keys(o).length === 0
}

export function isEmpty(o: any, emptyArraysAreNotEmpty?: boolean) {
  return (
    [null, undefined, '', NaN].includes(o) ||
    (Array.isArray(o) && !o.length && !emptyArraysAreNotEmpty) ||
    isEmptyObject(o)
  )
}

export function isInteger(v: number | string) {
  return /^[+-]{0,1}\d+$/.test(String(v))
}

export function isBase64(str: string, returnDecoded?: boolean) {
  if (!str) {
    return false
  }
  try {
    const decoded = atob(str)
    return returnDecoded ? decoded : true
  } catch (e) {
    return false
  }
}

// https://cs.opensource.google/go/x/crypto/+/refs/tags/v0.11.0:ssh/keys.go;l=37-44
const sshAlgs = [
  'ssh-rsa',
  'ssh-dss',
  'ecdsa-sha2-nistp256',
  'sk-ecdsa-sha2-nistp256@openssh.com',
  'ecdsa-sha2-nistp384',
  'ecdsa-sha2-nistp521',
  'ssh-ed25519',
  'sk-ssh-ed25519@openssh.com',
]

// https://tixtrack.atlassian.net/browse/TIC-2034?focusedCommentId=77966
export function isSSHPublicKey(str: string) {
  const binary = isBase64(str, true)
  if (binary === false) {
    return false
  }
  // Extract the algorythm name
  const first4 = (binary as string)
    .substr(0, 4)
    .split('')
    .map((c) => c.charCodeAt(0))
  const buffer = Uint8Array.from(first4).buffer
  const len = Number(new DataView(buffer).getUint32(0, false).toString(10))
  const alg = (binary as string).substr(4, len)
  return sshAlgs.includes(alg)
}

// Split by lines, chop the first and the last ones off, check that the rest is base64:
export function isPEM(str: string) {
  return isBase64(
    str
      .trim()
      .split(/[\r\n]+/g)
      .slice(1, -1)
      .join(''),
  )
}

export function isPrimitive(value: any): boolean {
  const type = typeof value
  return type != 'object' && type != 'function'
}

export function isTrueish(value: string): boolean | undefined {
  if (typeof value !== 'string') return

  const map = {
    '1': true,
    '0': false,
    on: true,
    off: false,
    enabled: true,
    disabled: false,

    true: true,
    false: false,
    t: true,
    f: false,

    yes: true,
    no: false,
    y: true,
    n: false,
  } as const

  const key = value.toLowerCase() as keyof typeof map

  return map[key]
}
